import { Link } from '@tanstack/react-router'
import { Home } from 'lucide-react'

import useTranslationStore from '@/language/useTranslationStore.ts'

export default function Footer() {
    const { t } = useTranslationStore()

    return (
        <Link
            aria-label={t('shared.notFound.backToStart')}
            to="/"
            className="text-background-dark bg-primary hover:bg-primary-hover shadow-primary/10 inline-flex items-center justify-center gap-2 rounded-lg px-5 py-2.5 text-sm font-bold shadow-lg transition-all hover:scale-[1.02] active:scale-[0.98]"
        >
            <Home size={18} />
            {t('shared.notFound.backToStart')}
        </Link>
    )
}
